module.exports = __webpack_public_path__ + "static/media/checkmark.46e8c47d.svg";